import { mainLogger as log } from "@/app/logger"
import ErrorPage from "@/pages/error/index.page"
import { Component, ErrorInfo, ReactNode } from "react"

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
  error: Error | null
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)

    this.state = { hasError: false, error: null }
  }
  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error }
  }
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    log.trace("An error has occurred", error, ".With information:", errorInfo)
    this.setState({ error })
  }

  render() {
    const { error } = this.state

    if (error) {
      return <ErrorPage error={error} />
    }

    return this.props.children
  }
}
